import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Search = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="bb4d0__a">
              <rect
                rx="0"
                height="48"
                width="48"
              />
            </clipPath>
          </defs>
          <g
            clipPath="url(#bb4d0__a)"
            style={{ mixBlendMode: 'passthrough' }}
          >
            <path
              fillRule="evenodd"
              d="M31.657 11.858c-5.468-5.467-14.332-5.467-19.8 0-5.467 5.467-5.467 14.332 0 19.799 5.468 5.467 14.332 5.467 19.8 0 5.467-5.467 5.467-14.332 0-19.8ZM9.029 9.03C16.06 2 27.456 2 34.485 9.03c6.551 6.55 6.997 16.896 1.337 23.963l5.737 5.738c.781.781.767 2.055-.014 2.836-.76.76-2.033.774-2.814-.007l-5.738-5.738c-7.067 5.66-17.412 5.215-23.964-1.337C2 27.455 2 16.06 9.03 9.03Z"
              style={{ mixBlendMode: 'passthrough' }}
              data-follow-fill="#455766"
              fill={_fill}
            />
          </g>
        </g>
      </svg>
    )
  }
)
